import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";
import { getError } from "../../../services/lib/getError";
import { getUserModels } from "../../../services/api/instances/modelsApi/methods";

export const getModelsAction = createAsyncThunk(
  "models/getModels",
  async (_, { rejectWithValue }) => {
    try {
      return await getUserModels();
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
  {
    condition(_, { getState }) {
      const models = (getState() as RootState).modelsState;

      if (models.isInitialized) return false;

      return true;
    },
  },
);
